import { UTC, DateRange }  from 'rewire-common';
import {
  Modal,
  Form,
  IFormContext,
  validator,
  field,
}                          from 'rewire-ui';
import scheduleModel       from './ScheduleModel';

export interface IUpdateJobEffectiveRangeDialogData {
  id:        string;
  startDate: UTC;
  endDate:   UTC;
}

export class UpdateJobEffectiveRangeDialogModel extends Modal {
  form:  Form;
  jobId: string;

  constructor() {
    super('Update Job Effective Range');

    this.form = Form.create((form: IFormContext) => ({
      startDate:                    form.date().label('Job Start Date'),
      endDate:                      form.date().label('Job End Date').validators(validator('>=', field('startDate'))),
      removeOverlappingAssignments: form.boolean().label('Remove Overlapping Assignments'),
    }), {}, {updateOnChange: true});

    this.action('cancel')
        .action('save', this.submit, { variant: 'contained', type: 'submit' });
  }

  reset() {
    this.form.reset();
  }

  load(data: IUpdateJobEffectiveRangeDialogData) {
    this.reset();
    this.jobId      = data.id;
    this.form.value = {
      startDate: data.startDate,
      endDate: data.endDate,
      removeOverlappingAssignments: true
    };
    this.open();
  }

  private save = async (): Promise<boolean> => {
    const newEffective                 = new DateRange(this.form.field.startDate.value, this.form.field.endDate.value);
    const removeOverlappingAssignments = this.form.field.removeOverlappingAssignments.value ?? true;

    if (await scheduleModel.updateJobEffectiveRange(this.jobId, newEffective, removeOverlappingAssignments)) {
      return true;
    }
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const updateJobEffectiveRangeDialogModel = new UpdateJobEffectiveRangeDialogModel();
export default updateJobEffectiveRangeDialogModel;
